module.exports = __webpack_public_path__ + "static/media/renshibankuai1.cf4c3cfe.png";